(function () {
  function applySwatchColors(root = document) {
    root.querySelectorAll('.shade-swatch[data-shade-hex]').forEach((btn) => {
      const hex = (btn.getAttribute('data-shade-hex') || '').trim();
      btn.style.setProperty('--shade-hex', hex);
      // extra safety
      if (hex) btn.style.backgroundColor = hex;
    });
  }

  function setSelected(pickerEl, shadeIndex, shadeName, btnEl) {
    pickerEl
      .querySelectorAll(`[data-shade-btn][data-shade-index="${shadeIndex}"]`)
      .forEach((b) => b.classList.remove('is-selected'));

    btnEl.classList.add('is-selected');

    const input = pickerEl.querySelector(`[data-shade-input="${shadeIndex}"]`);
    const label = pickerEl.querySelector(`[data-selected-label="${shadeIndex}"]`);

    if (input) input.value = shadeName;
    if (label) label.textContent = `Selected: ${shadeName}`;
  }

  function validateRequired(pickerEl) {
    const errors = [];
    const rows = pickerEl.querySelectorAll('[data-shade-row]');

    for (let i = 1; i <= rows.length; i++) {
      const input = pickerEl.querySelector(`[data-shade-input="${i}"]`);
      if (!input || !input.value) errors.push(`Please choose Shade ${i}.`);
    }

    const errBox = pickerEl.querySelector('[data-shade-errors]');
    if (errBox) {
      if (errors.length) {
        errBox.style.display = 'block';
        errBox.innerHTML = errors.map((e) => `<div>${e}</div>`).join('');
      } else {
        errBox.style.display = 'none';
        errBox.innerHTML = '';
      }
    }
    return errors.length === 0;
  }

  // Run once on load
  function boot() {
    applySwatchColors(document);
  }

  document.addEventListener('DOMContentLoaded', boot);

  // Shopify Theme Editor events (Dawn re-renders sections)
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
  document.addEventListener('shopify:section:deselect', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:block:select', boot);
  document.addEventListener('shopify:block:deselect', boot);

  // MutationObserver for dynamic DOM swaps
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (!m.addedNodes || !m.addedNodes.length) continue;

      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches?.('.shade-swatch[data-shade-hex]') ||
          node.querySelector?.('.shade-swatch[data-shade-hex]')
        ) {
          applySwatchColors(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Swatch click handler
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-shade-btn]');
    if (!btn) return;

    const picker = btn.closest('[data-shade-picker]');
    if (!picker) return;

    // Always ensure color is applied (theme can override button bg)
    const hex = (btn.getAttribute('data-shade-hex') || '').trim();
    btn.style.setProperty('--shade-hex', hex);
    if (hex) btn.style.backgroundColor = hex;

    const shadeIndex = btn.getAttribute('data-shade-index');
    const shadeName = btn.getAttribute('data-shade-name') || '';

    setSelected(picker, shadeIndex, shadeName, btn);
  });

  // Product form submit validation (product page)
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form) return;

      const picker = form.querySelector('[data-shade-picker]');
      if (!picker) return;

      if (!validateRequired(picker)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Modal AJAX add-to-cart
  async function ajaxAddToCart({ variantId, properties, qty = 1 }) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Add to cart failed');
    }
    return res.json();
  }

  // Modal open/close + add
  document.addEventListener('click', async function (e) {
    const openBtn = e.target.closest('[data-open-shade-modal]');
    const closeBtn = e.target.closest('[data-close-shade-modal]');
    const addBtn = e.target.closest('[data-modal-add]');

    if (openBtn) {
      const modalId = openBtn.getAttribute('data-open-shade-modal');
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.setAttribute('open', 'open');
        modal.classList.add('is-open');

        applySwatchColors(modal);
      }
      return;
    }

    if (closeBtn) {
      const modal = closeBtn.closest('dialog');
      if (modal) {
        modal.classList.remove('is-open');
        modal.removeAttribute('open');
        modal.close?.();
      }
      return;
    }

    if (addBtn) {
      const modal = addBtn.closest('dialog');
      const picker = modal?.querySelector('[data-shade-picker]');
      if (!modal || !picker) return;

      if (!validateRequired(picker)) return;

      const variantId = addBtn.getAttribute('data-variant-id');

      // Build properties dynamically (based on number of rows rendered)
      const properties = {};
      const rows = picker.querySelectorAll('[data-shade-row]');
      for (let i = 1; i <= rows.length; i++) {
        const val = picker.querySelector(`[data-shade-input="${i}"]`)?.value || '';
        properties[`Shade ${i}`] = val;
      }

      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');

      try {
        await ajaxAddToCart({ variantId, properties, qty: 1 });
        window.location.href = '/cart';
      } catch (err) {
        const errBox = picker.querySelector('[data-shade-errors]');
        if (errBox) {
          errBox.style.display = 'block';
          errBox.innerHTML = `<div>${err && err.message ? err.message : 'Add to cart failed'}</div>`;
        }
      } finally {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      }
    }
  });
})();